import { FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';

export const AddAStrap = <FormattedMessage {...commonMessages.addAStrap} />;
